'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SVGContainer = require('../SVGContainer');

var _SVGContainer2 = _interopRequireDefault(_SVGContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommentIcon = function CommentIcon(props) {
  return _react2.default.createElement(
    _SVGContainer2.default,
    props,
    _react2.default.createElement('path', { d: 'M27.5,6 L4.5,6 C4.224,6 4,6.224 4,6.5 L4,22.5 C4,22.776 4.224,23 4.5,23 L11,23 L11,26.5 C11,26.702 11.122,26.885 11.309,26.962 C11.371,26.987 11.436,27 11.5,27 C11.63,27 11.758,26.949 11.854,26.854 L15.707,23 L27.5,23 C27.776,23 28,22.776 28,22.5 L28,6.5 C28,6.224 27.776,6 27.5,6 L27.5,6 Z' })
  );
};

CommentIcon.propTypes = {
  size: _react.PropTypes.oneOf(['small', 'medium', 'large'])
};

exports.default = CommentIcon;